module.exports = _IndicoCoreReact;